import { useParams } from "react-router-dom"; 
import { ShopsList } from "../../../components/shared/shops/ShopsList";
import { PageContainer } from "../../../components/ui/PageContainer";
import PageHeader from "../../../components/ui/PageHeader";
import HeroSection from "../../../components/ui/HeroSection";
import { Clock, Star, Truck } from "lucide-react";
import PageHead from "../../../components/ui/PageHead";
import { useShopsBySector } from "@cabukaka/hooks"; // Ton nouveau hook

export default function ShopsPage() {
    const { slug } = useParams(); 
    const { shops, loading } = useShopsBySector(slug || "");

    return (
        <>
            <PageHead description="" title={`Boutiques | ${slug}`} />
            <PageContainer className="min-h-screen bg-gray-50">
                <PageHeader
                    breadcrumb={[
                        { label: "Boutiques", href: "/boutiques" },
                        { label: slug || "Secteur", href: "#" },
                    ]}
                />

                <HeroSection 
                    title={slug ? `Boutiques : ${slug}` : "Nos Boutiques"} 
                    description="Découvrez nos boutiques partenaires spécialisées"
                    more={
                        <div className="flex flex-wrap gap-3">
                            {[
                                { icon: Truck, label: 'Livraison rapide' },
                                { icon: Star, label: 'Qualité garantie' },
                                { icon: Clock, label: '24h/24 · 7j/7' },
                            ].map(({ icon: Icon, label }) => (
                                <div key={label} className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-white text-sm font-medium">
                                    <Icon className="w-4 h-4 text-orange-200" />
                                    {label}
                                </div>
                            ))}
                        </div>
                    } 
                />

                <div className="container mx-auto px-4 py-8">
                    {loading ? (
                        <div className="flex justify-center py-20">
                            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
                        </div>
                    ) : (
                        <ShopsList shops={shops} />
                    )}
                </div>
            </PageContainer>
        </>
    );
}